// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-popover:has( #upload-stats-pop-up-content ) {\n\tz-index: 1000000;\n}\n", "",{"version":3,"sources":["webpack://src/components/network-stats/network-stats.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;AACjB","sourcesContent":[".ant-popover:has( #upload-stats-pop-up-content ) {\n\tz-index: 1000000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
